import { NavLink } from 'react-router-dom';
import { DIAGRAM_SECTIONS } from '../routes/admin/diagrams.js';

const TABS = [
  { to: '/admin/health', label: 'Health' },
  ...DIAGRAM_SECTIONS.map((s) => ({ to: `/admin/diagrams/${s.key}`, label: s.title })),
];

/** The admin area: the health checks, and how Affily works, drawn. */
export function AdminTabs() {
  return (
    <nav aria-label="Admin" className="-mx-1 overflow-x-auto">
      <ul className="flex gap-1 px-1 text-sm">
        {TABS.map((tab) => (
          <li key={tab.to}>
            <NavLink
              to={tab.to}
              className={({ isActive }) =>
                `block whitespace-nowrap rounded-md px-3 py-1.5 ${
                  isActive
                    ? 'bg-accent-soft font-medium text-accent-ink'
                    : 'text-ink-muted hover:bg-paper-sunken hover:text-ink'
                }`
              }
            >
              {tab.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
